import { callApiWithToken } from './base';
import config from '../../config';

export const fetchCategories = async (token: string) =>
  callApiWithToken(`${config.urls.categories}`, token, 'GET');
